import request from "@/requests/request";

export const getLanguages = async ({
  signal,
}: IGenericHookOptions): Promise<IGetLanguagesRS> =>
  await request({
    url: "/v1/comply/languages",
    method: "GET",
    signal,
  }).then(res => res.data);

export const putLanguages = async (
  activeLanguageIds: IPutLanguages,
): Promise<[]> =>
  await request({
    url: "/v1/comply/languages/active",
    method: "PUT",
    body: {
      activeLanguageIds,
    },
  }).then(res => res.data);

export const getActiveLanguages = async ({
  signal,
}: IGenericHookOptions): Promise<IGetActiveLanguagesRS> =>
  await request({
    url: "/v1/comply/languages/active",
    method: "GET",
    signal,
  }).then(res => res.data);

export const getPrivacyCentreUrl = async ({
  signal,
}: IGenericHookOptions): Promise<IGetPrivacyCentreUrlRSData> =>
  await request({
    url: "/v1/code-snippets/privacy-centre/preview",
    method: "GET",
    signal,
  }).then(res => res.data);

export const getPrivacyCentreSnippets = async ({
  signal,
}: IGenericHookOptions): Promise<IGetPrivacyCentreSnippetsRSData> =>
  await request({
    url: "/v1/code-snippets/privacy-centre",
    method: "GET",
    signal,
  }).then(res => res.data);

export const postSendDeveloperEmail = async (email: string): Promise<void> =>
  await request({
    url: "/v1/code-snippets/privacy-centre/email",
    method: "POST",
    body: { emailAddresses: [email] },
  }).then(res => res.data);

export const getPolicies = async ({
  signal,
  params,
}: {
  signal: IGenericHookOptions["signal"];
  params: ITableParams;
}): Promise<IGetPoliciesRS> =>
  await request({
    url: `/v1/comply/policies`,
    method: "GET",
    signal,
    params,
  }).then(res => res.data);

export const postUpdatePolicy = async (body: IUpdatePolicyRQ): Promise<void> =>
  await request({
    url: "/v1/comply/policy",
    method: "POST",
    body,
  }).then(res => res.data);

export const postDeletePolicy = async (policyId: number): Promise<void> =>
  await request({
    url: `/v1/comply/policy/${policyId}`,
    method: "POST",
  }).then(res => res.data);

export const getBasicStyling = async (): Promise<IBasicStylingRSData> =>
  await request({
    url: "/v1/theme/basic-styling",
    method: "GET",
  }).then(res => res.data);

export const postBasicStyling = async (
  data: IBasicStyling,
): Promise<IPostBasicStylingRS> =>
  await request({
    url: "/v1/theme/basic-styling",
    method: "POST",
    body: data,
  }).then(res => res.data);
